import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
import { createContext, useContext } from "react";
import { IconTooltip } from "./IconTooltip";
const DescriptionListContext = /*#__PURE__*/ createContext(null);
const StyledLabelColor = styled('div')(({ backgroundColor, theme })=>({
        backgroundColor,
        borderRadius: theme.spacing(0.25),
        height: theme.spacing(2.5),
        marginRight: theme.spacing(1),
        width: theme.spacing(1)
    }));
const StyledDescriptionItem = styled('div')(({ direction, justifyContent, theme })=>({
        '&:not(:last-child)': {
            marginBottom: theme.spacing(1)
        },
        display: 'flex',
        justifyContent,
        ...direction === 'vertical' ? {
            alignItems: 'flex-start',
            flexDirection: 'column'
        } : {
            alignItems: 'center',
            gap: theme.spacing(1)
        }
    }));
export const DescriptionItem = (props)=>{
    const context = useContext(DescriptionListContext);
    if (!context) {
        throw new Error('DescriptionItem must be used within a DescriptionList');
    }
    return /*#__PURE__*/ _jsxs(StyledDescriptionItem, {
        direction: context.direction,
        justifyContent: context.justifyContent,
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                component: "dt",
                display: "flex",
                variant: "body1",
                children: [
                    props.labelColor && /*#__PURE__*/ _jsx(StyledLabelColor, {
                        backgroundColor: props.labelColor
                    }),
                    props.label,
                    props.tooltipTitle && /*#__PURE__*/ _jsx(IconTooltip, {
                        title: props.tooltipTitle
                    }),
                    context.divider
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: props.valueColor,
                component: "dl",
                "data-component": "descriptionValue",
                "data-testid": props['data-testid'],
                variant: "subtitle1",
                children: props.value
            })
        ]
    });
};
DescriptionItem.displayName = 'DescriptionItem';
const StyledDl = styled('dl')({
    margin: 0
});
export const DescriptionList = ({ children, direction = 'horizontal', divider = null, justifyContent = 'initial' })=>{
    return /*#__PURE__*/ _jsx(DescriptionListContext.Provider, {
        value: {
            direction,
            divider,
            justifyContent
        },
        children: /*#__PURE__*/ _jsx(StyledDl, {
            children: children
        })
    });
};
DescriptionList.displayName = 'DescriptionList';

//# sourceMappingURL=DescriptionItem.js.map